import chevronRight from "@assets/images/chevron-right.svg";
import { TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { CartDetailSortField, orderDetailUrl } from "@saleor/createOrder/urls";
import { CartCheckoutQuery } from "@saleor/graphql";
import useNavigator from "@saleor/hooks/useNavigator";
import { makeStyles } from "@saleor/macaw-ui";
import { renderCollection } from "@saleor/misc";
import { RelayToFlat, SortPage } from "@saleor/types";
import { getArrowDirection } from "@saleor/utils/sort";
import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";

interface ICartTableProps extends SortPage<CartDetailSortField> {
  data: RelayToFlat<CartCheckoutQuery["contractCheckouts"]>;
}

const useStyles = makeStyles(
  theme => ({
    centeredHeader: {
      "& > div": {
        justifyContent: "center"
      }
    },
    centeredCell: {
      textAlign: "center",
      color: theme.palette.grey[800],
      fontWeight: "bold",
      "& img": {
        cursor: "pointer"
      }
    },
    rowPointer: {
      cursor: "pointer"
    },
    tableHead: {
      "& .MuiTableCell-root, .MuiTableCell-root > div": {
        color: theme.palette.grey[600],
        fontWeight: "bold"
      }
    },
    colId: {
      color: theme.palette.grey[900]
    },
    colName: {
      color: theme.palette.grey[800]
    },
    colDetail: {
      color: theme.palette.grey[900]
    },
    noBold: {
      "& > div": {
        fontWeight: [400, "!important"] as any
      }
    },
    colorLight: {
      "& > div > div": {
        color: [theme.palette.grey[600], "!important"] as any
      }
    }
  }),
  { name: "CartTable" }
);

const CartTable: React.FC<ICartTableProps> = ({ data, sort, onSort }) => {
  const classes = useStyles();
  const navigate = useNavigator();

  return (
    <ResponsiveTable>
      <TableHead>
        <TableRow className={classes.tableHead}>
          <TableCellHeader>
            <FormattedMessage defaultMessage="#" />
          </TableCellHeader>
          <TableCellHeader>
            <FormattedMessage defaultMessage="Sold to" />
          </TableCellHeader>
          <TableCellHeader>
            <FormattedMessage defaultMessage="ชื่อลูกค้า" />
          </TableCellHeader>
          <TableCellHeader
            className={classes.centeredHeader}
            direction={
              sort.sort === CartDetailSortField.linesCount
                ? getArrowDirection(sort.asc)
                : undefined
            }
            arrowPosition="right"
            onClick={() => onSort(CartDetailSortField.linesCount)}
          >
            <FormattedMessage defaultMessage="จำนวนสินค้าในตะกร้า" />
          </TableCellHeader>
          <TableCellHeader
            className={classNames(
              classes.centeredHeader,
              classes.noBold,
              classes.colorLight
            )}
          >
            <FormattedMessage defaultMessage="ดูสินค้าในตะกร้า" />
          </TableCellHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {data &&
          renderCollection(
            data,
            (item, index) => (
              <TableRow
                key={item.id}
                onClick={() => navigate(orderDetailUrl(item.id))}
                className={classes.rowPointer}
              >
                <TableCell className={classes.colId}>{index + 1}</TableCell>
                <TableCell className={classes.colDetail}>
                  {item.customer.code}
                </TableCell>
                <TableCell className={classes.colName}>
                  {item.customer.name}
                </TableCell>
                <TableCell className={classes.centeredCell}>
                  {item.quantity}
                </TableCell>
                <TableCell className={classes.centeredCell}>
                  <img src={chevronRight} alt="" />
                </TableCell>
              </TableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={5}>
                  <FormattedMessage defaultMessage="ยังไม่มีสินค้าในตะกร้า" />
                </TableCell>
              </TableRow>
            )
          )}
      </TableBody>
    </ResponsiveTable>
  );
};

export default CartTable;
